import React from 'react';
import { PageContainer, Header, Content, Footer } from 'components/blocks';
import { reSubscribe } from 'services/mail';
import Unsubscribe from './Unsubscribe';
import UnsubscribeNext from '../UnsubscribeNext';
import { useLocation } from 'react-router';

export default function() {
  const location = useLocation();
  const isShardedUnsubscriptionEnabledInLink = location.search.includes(
    'sharded_unsubscription=true',
  );
  if (isShardedUnsubscriptionEnabledInLink) {
    return <UnsubscribeNext />;
  }
  return (
    <PageContainer>
      <Header title="Unsubscribe" />
      <Content>
        <Unsubscribe onReSubscribe={reSubscribe} />
      </Content>
      <Footer />
    </PageContainer>
  );
}
